function pano() {
  embedpano({
    xml: '/build/xml/tour.xml',
    target: 'pano',
    passQueryParameters: 'startscene,startlookat',
  });
}
